export { default } from './MerchantResult';
